
import { v4 as uuidv4 } from 'uuid';
import { TeacherFormData, TeacherDepartment } from '@/types/teacher.types';

export const useTeacherDepartments = (
  formData: TeacherFormData,
  setFormData: React.Dispatch<React.SetStateAction<TeacherFormData>>
) => {
  // Initialize empty department
  const emptyDepartment: TeacherDepartment = {
    id: '',
    name: '',
    subject: '',
    classType: '',
    startTime: '',
    endTime: '',
    days: []
  };
  
  // Add a new department
  const addDepartment = () => {
    const newDepartment: TeacherDepartment = {
      ...emptyDepartment,
      id: uuidv4()
    };
    
    setFormData(prev => ({
      ...prev,
      departments: [...prev.departments, newDepartment]
    }));
  };
  
  // Handle department change
  const handleDepartmentChange = (
    index: number,
    field: keyof TeacherDepartment,
    value: string | string[]
  ) => {
    const updatedDepartments = [...formData.departments];
    updatedDepartments[index] = {
      ...updatedDepartments[index],
      [field]: value
    };
    
    setFormData(prev => ({
      ...prev,
      departments: updatedDepartments
    }));
  };
  
  return { handleDepartmentChange, addDepartment };
};
